import { PurchasedItemFilter } from "../OrderFilters/PurchasedItemFilter.tsx";
import { B2B_CONTRACTS_ITEM_KEY } from "./salesFilters.ts";
import { FilterPopoverField } from "./FilterPopoverField.tsx";
import { describeSelectedOptions } from "./salesFormat.ts";

const B2B_CONTRACTS_OPTION = [
  { id: B2B_CONTRACTS_ITEM_KEY, label: "Contratti B2B" },
];

export function SoldItemFilterField({
  value,
  itemLabelOf,
  onChange,
}: {
  value: string[];
  itemLabelOf: (itemKey: string) => string;
  onChange: (itemKeys: string[]) => void;
}) {
  return (
    <FilterPopoverField
      summary={describeSelectedOptions(value, itemLabelOf, "Tutti")}
      isEmpty={value.length === 0}
      clearLabel="Rimuovi il filtro prodotto"
      onClear={value.length > 0 ? () => onChange([]) : undefined}
      panelWidthClassName="w-[28rem]"
    >
      {(close) => (
        <PurchasedItemFilter
          value={value}
          onApply={onChange}
          close={close}
          extraOptions={B2B_CONTRACTS_OPTION}
        />
      )}
    </FilterPopoverField>
  );
}
